/**
 * Maps Firebase Auth error codes to i18n translation keys.
 * Falls back to a generic message if the code is unknown.
 */
const errorMap = {
  // Login errors
  'auth/invalid-credential': 'errors.invalidCredential',
  'auth/wrong-password': 'errors.invalidCredential',
  'auth/user-not-found': 'errors.userNotFound',
  'auth/invalid-email': 'errors.invalidEmail',
  'auth/user-disabled': 'errors.userDisabled',

  // Registration errors
  'auth/email-already-in-use': 'errors.emailInUse',
  'auth/weak-password': 'errors.weakPassword',
  'auth/operation-not-allowed': 'errors.operationNotAllowed',

  // Rate limiting / abuse
  'auth/too-many-requests': 'errors.tooManyRequests',

  // Google login errors
  'auth/popup-closed-by-user': 'errors.popupClosed',
  'auth/popup-blocked': 'errors.popupBlocked',
  'auth/cancelled-popup-request': 'errors.popupClosed',
  'auth/account-exists-with-different-credential': 'errors.accountExistsDifferentCredential',
  'auth/unauthorized-domain': 'errors.unauthorizedDomain',

  // Network errors
  'auth/network-request-failed': 'errors.networkError',

  // Password reset
  'auth/expired-action-code': 'errors.expiredCode',
  'auth/invalid-action-code': 'errors.invalidCode',
};

/**
 * Extract the Firebase error code from an error object or message string.
 * Firebase errors come in formats like:
 *   - err.code = "auth/invalid-credential"
 *   - err.message = "Firebase: Error (auth/invalid-credential)."
 */
function extractErrorCode(err) {
  if (err?.code) return err.code;

  const match = err?.message?.match(/\(([^)]+)\)/);
  if (match) return match[1];

  return null;
}

/**
 * Get a user-friendly i18n translation key for a Firebase error.
 * Usage: setError(t(getFirebaseErrorKey(err)))
 */
export function getFirebaseErrorKey(err) {
  const code = extractErrorCode(err);
  return (code && errorMap[code]) || 'errors.generic';
}
